import React from 'react';
import { Form, withFormik, FastField, ErrorMessage, Field } from 'formik';
import Recaptcha from 'react-google-recaptcha';
import * as Yup from 'yup';
import { Row, Col } from '../../../ui/wrapper'
import { FormGroup, Input, Textarea, Error } from '../../../ui/form'
import Button from '../../../ui/button'
import { Center, InputField } from './styles';
import Anchor from '../../../../components/ui/anchor'


const HeaderForm = ({ setFieldValue, isSubmitting, values, errors, touched }) => (
  <Form
    name="inquire-solution"
    method="post"
    data-netlify="true"
    data-netlify-recaptcha="true"
    data-netlify-honeypot="bot-field"
    id="inquire-solution"
  >
    <Row>
      <Col lg={12}>
        <FormGroup mb="20px">
          <Field
            name="solution"
            id="solution"
            as="select"
            hover="2"
            error={touched.solution && errors.solution}
          >
            <option value="">What is the product you're inquiring about? *</option>
            <option value="Healthcare">MD Force healthcare automation</option>
            <option value="POS">CryptoConnect POS</option>
            <option value="Captcha">Recaptcha for research companies</option>
            <option value="Other">Other</option>
          </Field>
          <ErrorMessage component={Error} name="solution" />
        </FormGroup>
      </Col>
    </Row>
    <Row gutters={{ lg: 20 }}>
      <Col lg={6}>
        <FormGroup mb="20px">
          <Input
            as={FastField}
            type="text"
            name="name"
            component="input"
            aria-label="name"
            placeholder="Your Name *"
            error={touched.name && errors.name}
          />
          <ErrorMessage component={Error} name="name" />
        </FormGroup>
      </Col>
      <Col lg={6}>
        <FormGroup mb="20px">
          <Input
            as={FastField}
            type="text"
            name="company"
            component="input"
            aria-label="company"
            placeholder="Name of your Company *"
            error={touched.company && errors.company}
          />
          <ErrorMessage component={Error} name="company" />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col lg={12}>
        <FormGroup mb="20px">
          <Input
            id="email"
            aria-label="email"
            component="input"
            as={FastField}
            type="email"
            name="email"
            placeholder="Email address *"
            error={touched.email && errors.email}
          />
          <ErrorMessage component={Error} name="email" />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col lg={12}>
        <FormGroup mb="20px">
          <Textarea
            as={FastField}
            component="textarea"
            aria-label="message"
            id="message"
            rows="4"
            type="text"
            name="message"
            placeholder="We would love to hear your thoughts and share our experience with you. *"
            error={touched.message && errors.message}
          />
          <ErrorMessage component={Error} name="message" />
        </FormGroup>
      </Col>
    </Row>
    {values.name && values.email && values.message && (
      <InputField>
        <FastField
          component={Recaptcha}
          sitekey='6LfNndUZAAAAAL8_y_pmOMr7S-NygRaveUAPJ-FK'
          name="recaptcha"
          onChange={value => setFieldValue('recaptcha', value)}
        />
        <ErrorMessage component={Error} name="recaptcha" />
      </InputField>
    )}
    {values.success && (
      <InputField>
        <Center>
          <p><span role="img" aria-label="tick">✅</span> Your message has been successfully sent, Our team will contact you ASAP. In the meantime, feel free to contact us on social channels or call us if your project requires immediate attention.</p>
        </Center>
      </InputField>
    )}
    <Center>
      <p><small>By submitting this form, you confirm that you have read and agree to our <Anchor path="/privacy-policy">Privacy Policy.</Anchor></small></p>
      <Button secondary type="submit" disabled={isSubmitting}>
        Send Message
      </Button>
    </Center>
  </Form>
);

export default withFormik({
  mapPropsToValues: () => ({
    solution: '',
    name: '',
    company: '',
    email: '',
    message: '',
    recaptcha: '',
    success: false,
  }),
  validationSchema: () =>
    Yup.object().shape({
      solution: Yup.string().required('Product name is required'),
      name: Yup.string().required('Name is required'),
      company: Yup.string().required('Company name is required'),
      email: Yup.string()
        .email('Invalid email address')
        .required('Email is required'),
      message: Yup.string().required('Message is required'),
      recaptcha: Yup.string().required('🤖 Robots are not welcome yet!'),
    }),
  handleSubmit: async ({ solution, name, company, email, message, recaptcha }, { setSubmitting, resetForm, setFieldValue }) => {
    try {
      const encode = data =>
        Object.keys(data)
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
          .join('&');
      await fetch('/?no-cache=1', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({
          'form-name': 'inquire-solution',
          solution,
          name,
          company,
          email,
          message,
          'g-recaptcha-response': recaptcha,
        }),
      });
      await setSubmitting(false);
      await setFieldValue('success', true);
      setTimeout(() => resetForm(), 3000);
    } catch (err) {
      setSubmitting(false);
      setFieldValue('success', false);
      alert('Something went wrong, please try again!') // eslint-disable-line
    }
  },
})(HeaderForm);

